/**
 * What was going on when something was reported. It travels with feedback and is shown
 * nowhere — see `/specs/features/feedback.spec.md`.
 *
 * Only what the page itself knows is gathered here. What connected, and from where, is read
 * off the request by the server, which is the half no client could be trusted with anyway.
 */

import { config } from '~/config/env'

export interface AppContext {
  readonly app: 'web'
  /** The build this page was served from, so a report can be pinned to a deploy. */
  readonly appVersion: string
  readonly environment: string
  /** Where in the app they were, path and query — the feedback dialog opens over a page. */
  readonly screen: string
  readonly locale: string
}

export function appContext(): AppContext {
  return {
    app: 'web',
    appVersion: __BUILD_STAMP__,
    environment: config.environment,
    screen: `${window.location.pathname}${window.location.search}`,
    locale: navigator.language,
  }
}
